import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../nodeInstance";
import UploadFilePopUp_New from "../../../../ReusableComponents/UploadFile/UploadFileNew";
import UploadFilePopUp_New_Sadaad from "../../../../ReusableComponents/UploadFile/uploadFileSadaad";

export default function FinListDataSadaad({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
  setTrigger,
  trigger,
}) {
  const [empId, setEmpId] = React.useState();

  const [checkedItems, setCheckedItems] = useState({});
  const maxSelected = 1505;

  const handleCheckboxChange = (event, data, CheckboxType, employeeId) => {
    if (CheckboxType === "Local") {
      console.log(
        "employeeId to be seen in my console",
        employeeId,
        checkedItems
      );

      if (!checkedItems) {
        console.log("data and employeeId to be printed here", data, employeeId);
        return;
      }

      // Check if the employee already exists in employeeData
      let employeeExists = checkedItems?.employeeData.some(
        (data) => data.emp_id === employeeId
      );

      let updatedEmployeeData;
      if (employeeExists) {
        // If employee exists, filter them out (remove)
        updatedEmployeeData = checkedItems.employeeData.filter(
          (data) => data.emp_id !== employeeId
        );
      } else {
        // If employee does not exist, add them
        updatedEmployeeData = [
          ...checkedItems.employeeData,
          { emp_id: employeeId },
        ];
      }

      const obj = {
        sadaad_number: checkedItems.sadaad_number,
        employeeData: updatedEmployeeData,
      };

      console.log("updatedEmployeeData to be seen here", obj);
      setCheckedItems(obj);
      return;
    }

    setCheckedItems(data);
  };

  const [Popup, setPopUp] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);

  const popOpenDownload = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Checkbox",
        })
      );
    } else {
      downloadFile(empId);
    }
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Checkbox",
        })
      );
    } else {
      setPopUp(true);
      setEmpId(list);
    }
  };

  const sadaadReject = (sadaad_number) => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Checkbox",
        })
      );
    } else {
      reject(sadaad_number);
    }
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const dispatch = useDispatch();
  const apiCall = () => {
    updateData("123654");
  };
  console.log("checkedItems data to be printed in console.", checkedItems);
  const downloadFile = async (empId) => {
    // setDownloadLoading(true);

    const reqObject = checkedItems.employeeData.map((data) => data.emp_id);
    console.log(
      "checked item to be seen once clicked",
      checkedItems,
      reqObject
    );
    const object = {
      emp_id: reqObject,
      sadaad_number: checkedItems.sadaad_number,
    };
    try {
      const response = await nodeinstance.post(
        `/sadaad/downloadSadaadFinExcel`,
        object,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Sadaad_${checkedItems.sadaad_number}`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = (sadaadNumber) => {
    setIsCollapsed((prevCollapsed) => ({
      ...prevCollapsed,
      [sadaadNumber]: !prevCollapsed[sadaadNumber],
    }));
  };

  const reject = async (sadaadNumber) => {
    console.log(
      "SadaadNumber click to be printed in the console",
      sadaadNumber,
      checkedItems
    );
    const reqObject = {
      sadaadNumber: sadaadNumber,
      employeeID: checkedItems.employeeData.map((data) => data.emp_id),
    };
    try {
      // var type = {
      //   sadaadNumber: `${sadaadNumber}`,
      // };
      const res = await nodeinstance.post(`/sadaad/rejectSadaad`, reqObject, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        apiCall();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };

  //downlaod

  console.log("selected employee to be seen here in console", checkedItems);

  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpen()}
        >
          <p>Update Sadaad</p>
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpenDownload()}
          disabled={downloadLoading || list?.isLoading}
        >
          <p>Download</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <Search searchKey={["sadaad_number"]} setSearchWords={setSearchWords} />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div
        className={`auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        <div className="w-full inline-block rounded  uppercase">
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}
          {!list?.isLoading
            ? currentList?.map((data, index) => (
                <>
                  <button
                    className="grid grid-cols-table-sadaad-number m-2 p-2 bg-gray"
                    type="button"
                    aria-expanded={!isCollapsed[data.sadaad_number]}
                    aria-controls={`collapseWidthExample-${data.sadaad_number}`}
                  >
                    <button
                      className="grid grid-cols-table-sadaad-number bg-gray"
                      type="button"
                      onClick={() => toggleCollapse(data.sadaad_number)}
                      aria-expanded={!isCollapsed[data.sadaad_number]}
                      aria-controls={`collapseWidthExample-${data.sadaad_number}`}
                    >
                      <p className="text-pretty font-bold ">
                        {"sadaad number     " + data.sadaad_number}
                      </p>
                    </button>
                    <button
                      className="p-1 px-1 rounded-md bg-error text-white h-10px w-48"
                      onClick={() => {
                        sadaadReject(data.sadaad_number);
                      }}
                    >
                      <p>Reject</p>
                    </button>
                    <div>
                      <input
                        list={checkedItems}
                        type="checkbox"
                        checked={
                          checkedItems.sadaad_number === data.sadaad_number &&
                          checkedItems?.employeeData?.length > 0
                        }
                        onChange={(event) =>
                          handleCheckboxChange(event, data, "global")
                        }
                        disabled={
                          checkedItems[data.sadaad_number] &&
                          Object.values(checkedItems).filter(Boolean).length >=
                            maxSelected
                        }
                      />
                    </div>
                  </button>

                  <div
                    className={`${isCollapsed[data.sadaad_number] ? "visible" : "hidden"}  grid grid-cols-table-fin-sadaad auto-cols-min gap-5 p-2 bg-white w-full `}
                  >
                    {titles.map((t, index) => (
                      <div key={index}>
                        <p className="font-semibold uppercase">{t}</p>
                      </div>
                    ))}
                    {list?.isLoading && (
                      <LoadingWithLable className="col-span-6" />
                    )}
                    {!list?.isLoading && <NoDataFound />}

                    {!data?.isLoading
                      ? data.employeeData?.map((list, indexNu) => (
                          <React.Fragment key={indexNu}>
                            <PaginationIndex index={indexNu} />
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.emp_id || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.border_number || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={
                                  list.Iqamma_Sadaad === "Pending"
                                    ? "New Sadaad"
                                    : "Sadaad Renewal" || "-"
                                }
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.visa_provider || "-"}
                              />
                            </p>
                            <p className="overflow-x-hidden">
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.sponsor_id || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.client_name || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.iqama_applied_date || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={data.sadaad_number || "-"}
                              />
                            </p>

                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.terms || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={
                                  list.Iqamma_Sadaad === "Pending"
                                    ? list.iqama_fees || "-"
                                    : "-"
                                }
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={
                                  list.Iqamma_Sadaad === "Pending"
                                    ? list.work_permit_fees || "-"
                                    : "-"
                                }
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={
                                  list.Iqamma_Sadaad === "Pending"
                                    ? list.other_fees || "-"
                                    : "-"
                                }
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={list.sadaad_status || "-"}
                              />
                            </p>
                            <p>
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={String(
                                  list.Sadaad_employee_count || "-"
                                )}
                              />
                            </p>

                            <div className="flex items-center mb-0">
                              <input
                                list={checkedItems}
                                type="checkbox"
                                checked={
                                  checkedItems?.sadaad_number ===
                                    data.sadaad_number &&
                                  Array.isArray(checkedItems?.employeeData) &&
                                  checkedItems.employeeData.some(
                                    (item) => item.emp_id === list.emp_id
                                  )
                                }
                                onChange={(event) =>
                                  handleCheckboxChange(
                                    event,
                                    data.sadaad_number,
                                    "Local",
                                    list.emp_id
                                  )
                                }
                                // disabled={
                                //   checkedItems[data.sadaad_number] &&
                                //   Object.values(checkedItems).filter(Boolean)
                                //     .length >= maxSelected
                                // }
                                disabled={
                                  checkedItems.sadaad_number !=
                                  data.sadaad_number
                                }
                              />
                            </div>

                            <hr
                              className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                            />
                          </React.Fragment>
                        ))
                      : ""}
                  </div>
                </>
              ))
            : ""}
        </div>
        <div className="w-full"></div>
      </div>
      <Pagination />
      {Popup ? (
        <UploadFilePopUp_New_Sadaad
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Update Payment Details"}
          url={`/sadaad/updatesadaadPayment?sadaad_number=${checkedItems.sadaad_number}`}
          callBack={apiCall}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
